module.exports = __webpack_public_path__ + "static/media/doc-create-ic.a504b666.webp";